import ComponentLoader from "component/componentloader";
import ListEmpty from "component/listEmpty";
import Toggler from "component/toggler";
import dayjs from "dayjs";
import React from "react";
import { Notification } from "./navbar";

const NotificationDropdown = ({ notifications, notificationsLoading }) => {
    return (
        <div className={``}>
            <div className="flex items-center p-4 !border-b !border-[#E6E8F9]">
                <h4 className="mr-auto text-base font-normal text-main-dark">Notifications</h4>

                {false && (
                    <>
                        <span className="text-sm text-main-grey mr-2.5">Unread Only</span>
                        <Toggler />
                    </>
                )}
            </div>
            <div
                className={`overflow-y-auto mt-2 mb-4 px-6 h-[calc(100%-97px)] ${
                    !notifications?.length && "grid place-items-center"
                }`}
            >
                {notificationsLoading ? (
                    <div className="flex items-center justify-center h-full">
                        <ComponentLoader free className="" />
                    </div>
                ) : (
                    <>
                        {notifications?.length ? (
                            <>
                                {notifications.map((not, idx) => (
                                    <Notification
                                        key={not._id}
                                        text={not.body}
                                        date={dayjs(not.createdAt).fromNow()}
                                        idx={idx}
                                    />
                                ))}
                            </>
                        ) : (
                            <ListEmpty
                                title="There are no notifications yet"
                                text="Start trading with Tradevu to see your notifications invoice here"
                                className="!my-0 -translate-y-10"
                            />
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default NotificationDropdown;
